/**
 * Which customer site the signed-in person is looking at, for the environment tab (Dev and UAT only).
 *
 * The tab lives outside the app's state provider, so the provider tells it through this small store instead.
 * A page that goes wrong is then named in any screenshot of it: the same portal serves many customers, and
 * "the Reactive page was blank" is not much to go on without knowing which one.
 */

type Listener = (label: string) => void;

let current = '';
const listeners = new Set<Listener>();

export const setSiteLabel = (label: string) => {
  if (label === current) {
    return;
  }

  current = label;
  listeners.forEach((listener) => listener(label));
};

export const getSiteLabel = () => current;

export const onSiteLabel = (listener: Listener) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};
